import { isNullOrEmpty } from "../../../../shared/utility";

export const RentalExtension = function (data) {
  if (!data) data = {};
  this.firstName = data.firstName || null;
  this.lastName = data.lastName || null;
  this.email = data.email || null;
  this.rentalAgreementNum = data.rentalAgreementNum || null;
  if (!isNullOrEmpty(data?.returnDate)) {
    this.returnDate = data.returnDate || null;
  }
  if (!isNullOrEmpty(data?.totalAuth)) {
    this.totalAuth = data.totalAuth || null;
  }
  if (!isNullOrEmpty(data?.totalTaxes)) {
    this.totalTaxes = data.totalTaxes || null;
  }
};
